let api = window.SiteApi;

export default {
  props: {
    items: Array, // ['item', 'item'] or [{text: 'item', value: 'value'}, {text: 'item', value: 'value'}]
    label: String,
    validationsError: String,
    // multiple: Boolean,
    value: [String, Number],
    selectAttr: {
      required: true,
      type: Object
    }
  },
  template: `
    <div class="form-item form-select-item">
      <label v-if="label" :for="selectAttr.id">{{label}}</label>
      <select v-model="currentValue" v-bind="selectAttr" @change="update">
        <option
          v-for="option in items"
          :selected="checkSelected(option.value || option)"
          :key="option.value || option"
          :value="option.value || option">{{option.text || option}}</option>
      </select>
      <div class="validation-info">
        <div v-if="validationsError" class="error-server" :id="selectAttr['aria-describedby']">
          {{validationsError}}
        </div>
      </div>
    </div>`,
  mounted() {},
  data() {
    return {
      currentValue: '',
    };
  },
  methods: {
    checkSelected(option) {
      return option === this.value;
    },
    update(event) {
      this.$emit('input', this.currentValue);
      this.$emit('select', event.target.value);
    }
  },
  watch: {
    value() {
      this.currentValue = this.value;
    }
  }
};


// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/ui/ui-select.js